import api from 'api';
import { useDispatch, useReduxState } from 'hooks';
import { actions } from 'store';
import { CalendarEventDateString } from 'components/calendar';
import { ModalButtonWithForm } from 'components/common';
import { FormGroup, Select } from 'components/common/form';

const CertificatesAddCalendarEvent = ({
  calendarEvents,
  templateId,
  updateTemplates
}) => {
  const { dispatch } = useDispatch();
  const { messages } = useReduxState();

  const submit = async (values) => {
    await api.post(
      `/admin/certificate-templates/${templateId}/calendar-events`,
      {
        calendarEventId: values.calendarEventId
      }
    );
    await updateTemplates();
    dispatch(
      actions.addNotice({
        text: messages.commonAddCalendarEventSuccess,
        type: 'success'
      })
    );
  };

  return (
    <ModalButtonWithForm
      buttonIcon="plus"
      buttonText={messages.commonAddCalendarEvent}
      modalActionText={messages.commonAdd}
      modalTitle={messages.commonAddCalendarEvent}
      onSubmit={submit}
      pristineIsValid={false}
      stopPropagation={true}
    >
      {(formState) => (
        <FormGroup label={messages.eventCalendarEvent}>
          <Select
            field="calendarEventId"
            id={`certificate-templates-add-calendar-event-${templateId}`}
            options={calendarEvents.map((event) => ({
              helpText: (
                <CalendarEventDateString
                  startDate={event.startDate}
                  endDate={event.endDate}
                />
              ),
              label: event.title,
              value: event.id
            }))}
          />
        </FormGroup>
      )}
    </ModalButtonWithForm>
  );
};

export default CertificatesAddCalendarEvent;
